module.exports = __webpack_public_path__ + "media/images/compare/info-ae667fd8e8dd70f8adce92fe6a4e0f97.svg";